export const TRIAL_OFFER_QUERY_PARAM = 'offer';

export const TRIAL_OFFER_EVENTS = {
  viewed: 'Trial Offer Viewed',
  activated: 'Trial Offer Activated',
  dismissed: 'Trial Offer Dismissed',
  activationFailed: 'Trial Offer Activation Failed',
  cancelled: 'Trial Offer Cancelled',
  cancelFailed: 'Trial Offer Cancel Failed',
} as const;

export const TRIAL_OFFER_LINK_LOCATIONS = {
  offerDialog: 'Premium Trial Offer Dialog',
  cancelDialog: 'Premium Trial Cancel Dialog',
} as const;
